import { axiosInstance } from "../axiosInstance";

export const getAllUsers = async () => {
  const instance = await axiosInstance();
  return await instance.get("/profile/all");
};
